<template>
  <div class="card card-custom gutter-b" style="box-shadow: none">
    <div class="card-header card-header-tabs-line">
      <ul class="nav nav-dark nav-bold nav-tabs nav-tabs-line" role="tablist" ref="builder-tab">
        <li class="nav-item">
          <a class="nav-link active" v-on:click="setActiveTab" data-tab="0" data-toggle="tab" href="#" role="tab">
            Cadastro
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-on:click="setActiveTab" data-tab="1" data-toggle="tab" href="#" role="tab">
            Logomarca
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-on:click="setActiveTab" data-tab="2" data-toggle="tab" href="#" role="tab">
            Fiscal
          </a>
        </li>
      </ul>
    </div>

    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="card-body">
        <b-tabs class="hide-tabs" v-model="tabIndex">
          <b-tab active>
            <b-row>
              <b-col md="5">
                <b-form-group id="nome" label-for="responsavel" label="Nome/Razão Social">
                  <b-form-input v-model="$v.form.nome.$model" :state="validateState('nome')" autofocus>
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="cnpj_cpf" label="CNPJ" label-for="cnpj_cpf">
                  <b-form-input id="cnpj_cpf" name="cnpj_cpf" v-model="$v.form.cnpj_cpf.$model"
                    @input.native="onCpfCnpjInput($event, form, 'cnpj_cpf')" :state="validateState('cnpj_cpf')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2" v-if="form.cnpj_cpf !== null && form.cnpj_cpf.length > 14">
                <button type="button" style="margin-top: 25px" @click="consultaReceita"
                  class="btn btn-primary font-weight-bold">
                  Consultar CNPJ
                </button>
              </b-col>
            </b-row>
            <b-row v-show="form.cnpj_cpf">
              <b-col md="6" v-show="juridica">
                <b-form-group id="nome_fantasia" label="Nome Fantasia" label-for="nome_fantasia">
                  <b-form-input id="nome_fantasia" name="nome_fantasia" v-model="$v.form.nome_fantasia.$model"
                    :state="validateState('nome_fantasia')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3" v-show="juridica">
                <template>
                  <b-form-group id="inscricao_municipal" label="Insc. Municípal" label-for="inscricao_municipal">
                    <b-form-input id="inscricao_municipal" name="inscricao_municipal" v-model="form.inscricao_municipal"
                      placeholder="">
                    </b-form-input>
                  </b-form-group>
                </template>
              </b-col>
              <b-col md="3">
                <b-form-group id="ie_rg" label="Insc. Estadual" label-for="ie_rg">
                  <b-form-input id="ie_rg" name="ie_rg" v-model="form.ie_rg" :state="validateState('ie_rg')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group id="responsavel" label="Responsável" label-for="responsavel">
                  <b-form-input id="responsavel" name="responsavel" v-model="form.responsavel" placeholder=""
                    :state="validateState('responsavel')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="telefone" label="Telefone" label-for="example-input-0">
                  <b-form-input v-mask="['(##) #### ####', '(##) # #### ####']" v-model="$v.form.fone.$model"
                    :state="validateState('fone')" aria-describedby="input-0-live-feedback">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="email" label="E-mail" label-for="form.email">
                  <b-form-input id="form.email" name="form.email" v-model="$v.form.email.$model"
                    :state="validateState('email')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="email" label="Site/Instagram" label-for="form.site">
                  <b-form-input id="form.site" name="form.site" v-model="form.site">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group label="CEP" label-for="form.cep">
                  <b-form-input ref="cep" id="form.cep" name="form.cep" v-model="form.cep" v-mask="['#####-###']"
                    @change="consultaCep" aria-describedby="form.cep" :state="validateState('cep')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group style="margin-top: 30px">
                  <a class="btn btn-primary font-weight-bold" @click="consultaCep">
                    Consultar CEP
                  </a>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Número" label-for="form.numero">
                  <b-form-input id="form.numero" name="form.numero" v-model="form.numero" aria-describedby="form.numero"
                    :state="validateState('numero')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bairro" label-for="form.bairro">
                  <b-form-input id="form.bairro" name="form.bairro" v-model="form.bairro" aria-describedby="form.bairro"
                    :state="validateState('bairro')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Logradouro" label-for="form.logradouro">
                  <b-form-input id="form.logradouro" name="form.logradouro" v-model="form.logradouro"
                    aria-describedby="form.logradouro" :state="validateState('logradouro')">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Complemento" label-for="form.complemento">
                  <b-form-input id="form.complemento" name="form.complemento" v-model="form.complemento"
                    aria-describedby="form.complemento">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Cidade" label-for="form.cidade">
                  <VueSelect label="cidade" @input="setCidade" :options="cidades" v-model="cidade" @search="onSearch">
                    <template slot="no-options">
                      Informe o nome da cidade
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.cidade + " - " + option.uf }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.cidade + " - " + option.uf }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <b-card no-body class="overflow-hidden" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6" v-if="urlLogo">
                  <b-card-img :src="urlLogo" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="6" v-else-if="logo">
                  <b-card-img :src="urlDigital + logo" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="6" v-else>
                  <b-card-img :src="'https://sistemanfce.fra1.digitaloceanspaces.com/logos/semlogo.png'"
                    class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Logomarca">
                    <b-card-text>
                      Logomarca será utilizada para relátorios e impressão de
                      documentos.
                    </b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
            <b-col md="12">
              <div class="mt-3">
                Selecione a logomarca: {{ logomarca ? logomarca.name : "" }}
              </div>
              <b-form-file accept=".jpg, .png" placeholder="Selecione o logomarca..."
                @change="setLogomarca"></b-form-file>
            </b-col>
          </b-tab>
          <b-tab>
            <b-row>
              <b-col md="2">
                <b-form-group id="optante_simples" label-for="optante_simples" label="Optante do Simples">
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" v-model="form.optante_simples" :checked="form.optante_simples == true" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="aliquota_cbs" label-for="aliquota_cbs">
                  <template #label>
                    % Alíquota CBS
                    <span class="ml-1 text-muted" v-b-tooltip.hover
                      title="Campo referente à Reforma Tributária (CBS). Esta informação/uso pode mudar conforme regulamentação e cronograma de implantação."
                      style="cursor: help;">
                      <i class="fas fa-info-circle"></i>
                    </span>
                  </template>

                  <b-form-input disabled v-money="configMoney" id="form.aliquota_cbs" name="form.aliquota_cbs"
                    v-model="form.aliquota_cbs" />
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="form.optante_simples">
                <b-form-group id="aliquota_simples" label-for="aliquota_simples" label="Alíquota Simples">
                  <b-form-input v-money="configMoney" id="form.aliquota_simples" name="form.aliquota_simples"
                    v-model="form.aliquota_simples">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="cnae" label-for="cnae" label="CNAE">
                  <b-form-input id="form.cnae" name="form.cnae" v-model="form.cnae" aria-describedby="form.cnae"
                    v-mask="['####-#/##']">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="CRT" label-for="crt">
                  <select name="crt" id="crt" v-model="form.crt" class="form-control">
                    <option value="1" v-show="form.optante_simples">1</option>
                    <option value="2" v-show="form.optante_simples">2</option>
                    <option value="4" v-show="form.optante_simples">4</option>
                    <option value="3" v-show="!form.optante_simples">3</option>
                  </select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <div class="mt-3">
                  Selecione o certificado:
                  {{ certificado ? certificado.name : "" }}
                </div>
                <b-form-file placeholder="Selecione o certificado..." @change="setImage"></b-form-file>
              </b-col>
              <b-col md="4">
                <div class="mt-4">Senha do certificado</div>
                <b-form-group id="senha_certificado" label-for="senha_certificado">
                  <b-form-input v-if="checkNewCeritificate" disabled type="password" id="form.senha_certificado"
                    name="form.senha_certificado" v-model="form.senha_certificado"
                    aria-describedby="form.senha_certificado">
                  </b-form-input>
                  <b-form-input v-if="!checkNewCeritificate" type="password" id="form.senha_certificado"
                    name="form.senha_certificado" v-model="form.senha_certificado"
                    aria-describedby="form.senha_certificado">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2" v-if="form.validade_certificado">
                <div class="mt-4">Val. do certificado:</div>
                <span><strong>{{ form.validade_certificado }}</strong></span>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>

      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <button type="submit" ref="submit_emitente" class="btn btn-primary font-weight-bold">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { mask } from "vue-the-mask";
import {
  SistemaMixin,
  EmitenteMixin,
  ValidacaoMixin,
} from "@/modules/Application";
import EmitenteData, { EmitenteDataRequired } from "./EmitenteData";
import VueSelect from "vue-select";
import loadsh from "loadsh";
import "vue-select/dist/vue-select.css";
import { VMoney } from "v-money";
import { onboardStore } from "../../../onboardStore";

export default {
  name: "app-emitente-form",
  props: {
    url: {
      type: String,
    },
    conta: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    VueSelect,
  },
  directives: {
    mask,
    money: VMoney,
  },
  mixins: [validationMixin, SistemaMixin, EmitenteMixin, ValidacaoMixin],
  watch: {
    emitente(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.form.cnpj_cpf = this.formatCpfCnpj(newValue.cnpj_cpf);
      }
    },
    logo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.logo = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["licenca"]),
  },
  data() {
    return {
      onboardStore,
      tabIndex: 0,
      form: {},
      cidades: [],
      file: null,
      certificado: null,
      logo: null,
      checkNewCeritificate: true,
      configMoney: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      urlDigital: null,
      logomarca: null,
      cidade: null,
      juridica: true,
      emitente: new EmitenteData({}),
      urlLogo: null,
    };
  },
  validations: {
    form: EmitenteDataRequired,
  },
  async mounted() {
    await this.getDataInit();
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);

      this.urlDigital = process.env.VUE_APP_DIGITAL_BASE_URL;

      const data = await this.getDadosEmitente();

      this.setLoading(false);

      if (!data.id_empresa || data == null) {
        return this.$toast.error("Emitente não encontrado!");
      }

      this.emitente = new EmitenteData(data);
      this.logo = data.logo;
      this.cidade = data.cidade;

      if (data.cnpj_cpf && data.cnpj_cpf.length < 14) {
        this.juridica = false;
      }
      if (this.emitente.cidade) {
        this.setCidade(this.emitente.cidade);
      }

      if (this.emitente.aliquota_simples) {
        this.emitente.aliquota_simples = this.numberToReal(
          this.emitente.aliquota_simples,
          2
        );
      }
    },
    setCidade(cidade) {
      if (cidade.id_cidade) {
        this.form.id_cidade = cidade.id_cidade;
      }
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades = city;
      loading(false);
    }, 350),
    async consultaCep() {
      this.setLoading(true);
      const cep = await this.getCep(this.form.cep);

      if (cep.length == 0) {
        this.setLoading(false);
        return;
      }

      this.form.logradouro = cep.logradouro;
      this.form.bairro = cep.bairro;

      if (cep.erro) {
        this.setLoading(false);
        this.$toast.warning("Confira o CEP informado!");
        return;
      }

      const city = await this.getCidadeByUF(cep.localidade, cep.uf);

      this.cidades = city;
      this.setLoading(false);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },

    setImage(event) {
      this.certificado = event.target.files[0];
      this.checkNewCeritificate = false;
    },

    async setLogomarca(event) {
      this.logomarca = await event.target.files[0];
      this.urlLogo = URL.createObjectURL(this.logomarca);
    },
    async consultaReceita() {
      this.setLoading(true);
      try {
        const receita = await this.getConsultaReceita(this.form.cnpj_cpf);
        this.form.nome = receita.nome;
        this.form.nome_fantasia = receita.nome_fantasia ?? null;
        this.form.responsavel = receita.responsavel ?? null;
        this.form.numero = receita.endereco.numero ?? null;
        this.form.bairro = receita.endereco.bairro ?? null;
        this.form.logradouro = receita.endereco.logradouro ?? null;
        this.form.cep = receita.endereco.cep ?? null;
        this.form.complemento = receita.endereco.complemento ?? null;
        this.form.cnae = receita.cnae ?? null;
        this.form.id_cidade = receita.endereco.cidade.id_cidade ?? null;
        this.form.cidade = receita.endereco.cidade ?? null;
        this.form.crt = receita.crt ?? 1;

        this.$toast.success(
          "Dados carregados com sucesso, verifique os dados!"
        );
      } catch (error) {
        console.log(error);
      }

      this.setLoading(false);
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_emitente"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (!this.validaCpfCnpj(this.form.cnpj_cpf)) {
          return this.$toast.error("CNPJ/CPF informado é inválido!");
        }

        this.form.cnpj_cpf = this.normalizeCpfCnpj(this.form.cnpj_cpf);

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        let emissor = new FormData();

        if (
          Number(this.licenca?.id_plan) === 4 ||
          Number(this.licenca?.id_plan) === 5
        ) {
          if (!this.form.inscricao_municipal) {
            this.$toast.warning("Preencha a inscrição municipal!");
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            submitButton.removeAttribute("disabled", "");
            return;
          }
        }

        if (this.certificado !== null) {
          emissor.append("nome_certificado", this.certificado);
        }

        if (this.logomarca !== null) {
          emissor.append("logo", this.logomarca);
        }

        if (this.form.senha_certificado !== null) {
          emissor.append("senha_certificado", this.form.senha_certificado);
        }

        if (this.form.complemento !== null) {
          emissor.append("complemento", this.form.complemento);
        }

        if (this.form.inscricao_municipal !== null) {
          emissor.append("inscricao_municipal", this.form.inscricao_municipal);
        }

        if (this.form.nome_fantasia !== null) {
          emissor.append("nome_fantasia", this.form.nome_fantasia);
        }

        if (this.form.site !== null) {
          emissor.append("site", this.form.site);
        }

        if (this.form.fone !== null) {
          emissor.append("fone", this.form.fone);
        }

        if (!this.form.optante_simples) {
          this.form.aliquota_simples = null;
        }

        emissor.append("id_empresa", this.emitente.id_empresa);
        emissor.append("nome", this.form.nome);
        emissor.append("cnpj_cpf", this.form.cnpj_cpf);
        emissor.append("ie_rg", this.form.ie_rg);
        emissor.append("responsavel", this.form.responsavel);
        emissor.append("cep", this.form.cep);
        emissor.append("logradouro", this.form.logradouro);
        emissor.append("numero", this.form.numero);
        emissor.append("bairro", this.form.bairro);
        emissor.append("fiscal", true);
        emissor.append("crt", this.form.crt);
        emissor.append("cnae", this.form.cnae);
        emissor.append("optante_simples", this.form.optante_simples);
        emissor.append("aliquota_simples", this.form.aliquota_simples);
        emissor.append("id_cidade", this.form.id_cidade);
        emissor.append("email", this.form.email);
        emissor.append("site", this.form.site);

        await this.$http.post(this.url, emissor);
        this.$emit("formSubmetido");
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );

        this.$toast.success("Emitente atualizado com sucesso!");

        submitButton.removeAttribute("disabled", "");

        if (this.onboardStore.currentStep > 0) {
          this.onboardStore.currentStep = 4;
        }

        await this.getDataInit();
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
